export enum RequestType {
	PAY_BILL = 'PAY_BILL',
	TOP_UP = 'TOP_UP',
	GROUP_TOP_UP = 'GROUP_TOP_UP',
}
export type Account = {
	accountId: string;
	accountName: string;
	adminsCount: number;
	documentId: string;
	documentType: string;
};
export type SinglePaymentHistory = {
	account: Account;
	paymentRequestId: string;
	paymentRequestType: RequestType;
	paymentDate: string;
	paymentMethod: string;
	amount: AmountType;
	itemsCount: number;
	accountId: number;
	billNumberList: BillsNumberList[];
	phoneNumber?: string;
	username?: string;
};

export type BillsNumberList = {
	billNumber: string;
	billingId: string;
	accountId: string;
	amount: AmountType;
};

export type AmountType = {
	unit: string;
	value: number;
};
